import React, {useRef, useState} from "react";
import "./SelectCoverVideo.scss";
import CoverFromPlayer from "./CoverFromPlayer";
import CoverFromUpload from "./CoverFromUpload";
import {Button} from "../../../../components/Button";

const SelectCoverVideo = ({
                              currentMedia = {}
                          }) => {
    let refUploadCover = useRef();
    const [selectChoice, setSelectChoice] = useState(0);

    let arrayChoice = [
        <div className={"choice"}>
            <Button size={"small"}
                    btnStyle={"primary-reverse"}
                    onClick={() => setSelectChoice(1)}
                    content={"Utiliser une image depuis votre vidéo"}/>
            <Button size={"small"}
                    btnStyle={"primary-reverse"}
                    onClick={() => setSelectChoice(2)}
                    content={"Utiliser une image personnalisée"}/>
        </div>,
        <CoverFromPlayer currentMedia={currentMedia} goBack={()=>setSelectChoice(0)} handleClose={()=>setSelectChoice(0)} />,
        <CoverFromUpload
            ref={refUploadCover}
            mediaId={currentMedia._id}
            handleClose={()=> {
                setSelectChoice(0);
                refUploadCover.current.cleanUpload();
            }}
            uploadPath={"/medias/upload-cover-video"}
        />
    ];

    return (
        <div id={"select-cover-video"}>
            {arrayChoice[selectChoice]}
        </div>
    )
}

export default SelectCoverVideo;